// extracted by mini-css-extract-plugin
module.exports = {"power-backup-au-faq":"AuFaq_power-backup-au-faq__SkwnJ"};